import { useState, useEffect, useRef } from 'react';
import api from '../../api';

const nullHandler = data => data;

export default (resource, defaultData, dataHandler = nullHandler) => {
  const [data, setData] = useState(defaultData);
  const [fetching, setFetching] = useState(true);
  const [error, setError] = useState(null);
  const isCancelled = useRef(false);

  useEffect(() => {
    const fetchData = async () => {
      setFetching(true);

      try {
        const response = await api.get(resource);
        if (isCancelled.current) return;
        setData(dataHandler(response));
      } catch (e) {
        if (isCancelled.current) return;
        setError(e);
      }

      setFetching(false);
    };

    fetchData();

    return () => {
      isCancelled.current = true;
    };
  }, [resource, dataHandler]);

  return [data, { fetching, error, resource }];
};
